import { render, staticRenderFns } from "./cLagerbestand.vue?vue&type=template&id=3a6084ae&scoped=true"
import script from "./cLagerbestand.vue?vue&type=script&lang=js"
export * from "./cLagerbestand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6084ae",
  null
  
)

export default component.exports